import {Injectable} from '@angular/core';
import {BaseApiService} from '../../base-service/base-api.service';

@Injectable()
export class LocationService extends BaseApiService {
    /**
     * Gets the business units
     */
    public getBusinessUnits() {
        return this.get('Foundation/Location/BusinessUnits');
    }

    /**
     * Gets the active  business units
     */
    public getActiveBusinessUnits() {
        return this.get('Foundation/Location/ActiveBusinessUnits');
    }

}
